import { render, staticRenderFns } from "./TrialBalanceV2.vue?vue&type=template&id=3bbcf3b2&scoped=true"
import script from "./TrialBalanceV2.vue?vue&type=script&lang=js"
export * from "./TrialBalanceV2.vue?vue&type=script&lang=js"
import style0 from "./TrialBalanceV2.vue?vue&type=style&index=0&id=3bbcf3b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbcf3b2",
  null
  
)

export default component.exports